import { useMemo } from "react";
import { useFetchUser } from "../../api/hooks/useUser";
import { Router } from "../../components/Router/Router";
import { getRouterConfig } from "../../components/Router/utils";
import { useInboxConfig } from "../../hooks/useInboxConfig";
import { getNewUniqueRouteKey } from "../../navigationConfig";
import {
  mmNavigationConfig,
  nonMenuRoutes,
} from "../../navigationConfig/mmNavigationConfig";

export const RoutesGeneratorWithMMOptions = () => {
  const [user] = useFetchUser();
  const inboxConfig = useInboxConfig();

  const routerConfig = useMemo(
    () =>
      getRouterConfig(
        [
          ...mmNavigationConfig,
          ...nonMenuRoutes,
          /**
           * We want to fallback to the hub, as there are still paths leading
           * to it we don't know about, in the future when we want to add our own
           * 404 page we will need to make sure every paths loading the hub are
           * in the config
           */
          {
            key: getNewUniqueRouteKey("fallback"),
            path: "/*",
            mfe: { name: "container", entry: "app" },
          },
        ],
        {
          userRights: user?.rights ?? [],
          inboxVersion: inboxConfig.inboxVersion,
        }
      ),
    [user, inboxConfig]
  );

  return <Router config={routerConfig} />;
};
